<template>
  <VoteBase>
    <template v-slot:voteMain>
      <div>
        <b-card :header="'点赞实例' + (oversea ? overseaTag : '')">
          <b-link :to="{name: 'vote-create', query: {oversea: oversea}}">
            <b-button variant="outline-primary" :style="{marginBottom: '18px'}" >
              创建实例
            </b-button>
          </b-link>
          <b-link :to="{name: 'vote-reward-history', query: {oversea: oversea}}">
            <b-button variant="outline-primary" :style="{marginBottom: '18px'}" >
              查询用户奖励历史
            </b-button>
          </b-link>
          <b-form-checkbox v-if="overseaShow" v-model="oversea" name="check-button" class="float-right type-check" switch>海外版</b-form-checkbox>
          <b-table show-empty responsive="sm" :busy="items === null" :items="items" :fields="fields" :emptyText="tableEmptyText" >
            <template #cell(vote_op)="data">
              <b-link :to="{name: 'vote-update', params: {appId: data.item.app_id}, query: {oversea: oversea}}">
                <b-button size="sm" variant="outline-warning">
                  <i class="fa fa-edit" /> 编辑
                </b-button>
              </b-link>
              <b-button size="sm" variant="outline-primary" @click="checkDetail(data.item.app_id)">
                <i class="fa fa-search" /> 查看详情
              </b-button>
              <b-link :to="{name: 'vote-item', params: {appId: data.item.app_id}, query: {oversea: oversea}}">
                <b-button size="sm" variant="outline-success">
                  <i class="fa fa-ticket" /> 配置投票项
                </b-button>
              </b-link>
              <b-link :to="{name: 'vote-reward', params: {appId: data.item.app_id}, query: {oversea: oversea}}">
                <b-button size="sm" variant="outline-success">
                  <i class="fa fa-gift" /> 配置奖励
                </b-button>
              </b-link>
              <b-button v-if="$store.getters.loginInfo.email === data.item.creator_urs" size="sm" variant="outline-primary" @click="authList(data.index)" >
                <i class="fa fa-users" /> 授权列表
              </b-button>
              <b-button size="sm" variant="outline-success" @click="statisticsShow(data.index)" >
                <i class="fa fa-database" /> 数据统计
              </b-button>
              <b-button v-if="$store.getters.loginInfo.email === data.item.creator_urs" size="sm" variant="outline-danger" @click="deleteTip(data.index)" >
                <i class="fa fa-trash-o" /> 删除
              </b-button>
            </template>

            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle" />
                <strong>加载中...</strong>
              </div>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            prev-text="<<"
            next-text=">>"
            @change="changePage"
            hide-goto-end-buttons
            first-number
            last-number
          />
        </b-card>
        <VoteAuthList ref="authList" />
        <TipModal ref="tip" :tipData="tipData">
          <template v-slot:footer>
            <b-button size="sm" variant="outline-dark" @click="cancelDelete()" >取消</b-button>
            <b-button size="sm" variant="outline-danger" @click="deleteVote()" >删除</b-button>
          </template>
        </TipModal>
        <VoteDetail ref="detail" :showData="data" />
        <VoteStatistics ref="statistics" :showData="statisticsData" :oversea="oversea" />
      </div>
    </template>
  </VoteBase>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'
import VoteAuthList from '@/components/Vote/VoteAuthList'
import TipModal from '@/components/TipModal'
import VoteBase from './Base'
import VoteDetail from '@/components/Vote/VoteDetail'
import VoteStatistics from '@/components/Vote/VoteStatistics'

export default {
  name: 'vote',
  components: {VoteAuthList, TipModal, VoteBase, VoteDetail, VoteStatistics},
  mixins: [Error],
  data: () => {
    return {
      items: null,
      fields: consts.VOTE_FIELDS,
      currentPage: 1,
      perPage: consts.DEFAULT_PER_PAGE,
      totalRows: 0,
      tipData: {
        data: null,
        title: '',
        msg: '',
        headerBgVariant: '',
        headerTextVariant: ''
      },
      listOrder: '-instance__create_time',
      tableEmptyText: consts.TABLE_EMPTY_TEXT,
      detailObj: {},
      data: null,
      statisticsData: null,
      firstSave: true,
      oversea: false,
      overseaShow: false,
      overseaTag: consts.overseaTag
    }
  },
  created () {
    this.oversea = this.$route.params.oversea || false
    if (this.firstSave && this.$route.params.save) {
      this.totalRows = sessionStorage.getItem('voteRow')
      this.currentPage = sessionStorage.getItem('votePage')
      this.firstSave = false
    }
    this.$ajax.get(api.getAdminLoginInfo()).then((data) => {
      if (data.admin_info.edition) {
        this.overseaShow = true
      }
      this.$store.dispatch('setUser', data.admin_info)
      this.changePage(this.currentPage)
    }, (res) => {
      this.$store.dispatch('setUser', null)
    })
  },
  beforeDestroy () {
    sessionStorage.setItem('votePage', this.currentPage)
    sessionStorage.setItem('voteRow', this.totalRows)
  },
  watch: {
    oversea (val) {
      this.changePage(this.currentPage)
    }
  },
  methods: {
    changePage (page) {
      let params = {
        'where': JSON.stringify({'admin_urs': this.$store.getters.loginInfo.email}),
        'order': this.listOrder
      }
      this.currentPage = page
      api.fetchVoteListData(this, api.getVoteList(), 'follow_vote', params, this.oversea ? consts.OVERSEA_TYPE : '')
    },
    deleteTip (idx) {
      this.tipData = {
        data: {app_id: this.items[idx].app_id},
        title: '警告',
        msg: '是否确定删除实例【' + this.items[idx].app_name + '】？',
        headerBgVariant: 'danger',
        headerTextVariant: 'light'
      }
      this.$refs.tip.modalShow()
    },
    deleteVote () {
      api.deleteVoteData(this, api.getVoteDelete(), 'GET', this.$refs.tip.modalData.data, this.oversea ? consts.OVERSEA_TYPE : '', this.deleteCallback)
    },
    deleteCallback () {
      this.$refs.tip.modalHide()
      this.changePage(this.currentPage)
    },
    authList (idx) {
      this.$refs.authList.show(this.items[idx].app_id, this.items[idx].app_name, this.oversea)
    },
    cancelDelete () {
      this.$refs.tip.modalHide()
    },
    checkDetail (appId) {
      if (this.detailObj.hasOwnProperty(appId)) {
        this.data = this.detailObj[appId]
        this.showDetail()
      } else {
        api.detailVoteData(this, api.getVoteDetail(), 'GET', 'data', {app_id: appId}, this.oversea ? consts.OVERSEA_TYPE : '', this.showDetail)
      }
    },
    showDetail () {
      this.$refs.detail.modalShow()
    },
    statisticsShow (idx) {
      let curData = this.items[idx]
      this.statisticsData = {
        appId: curData.app_id,
        appName: curData.app_name,
        startTime: curData.ins_start_time,
        endTime: curData.ins_end_time
      }
      this.$refs.statistics.modalShow()
    }
  }
}
</script>

<style>
  .type-check {
    padding-top: 6px;
  }
</style>



// WEBPACK FOOTER //
// Vote.vue?5bafddb3